import PropTypes from 'prop-types';
import React from 'react';

import Loader from 'Component/Loader';
import MyAccountCustomerForm from 'Component/MyAccountCustomerForm';
import MyAccountStatusMessage from 'Component/MyAccountStatusMessage';
import {
    MyAccountInformation as SourceMyAccountInformation
} from 'SourceComponent/MyAccountInformation/MyAccountInformation.component';

import './MyAccountInformation.override.style';

/** @namespace PeggysagePwa/Component/MyAccountInformation/Component */
export class MyAccountInformationComponent extends SourceMyAccountInformation {
    static propTypes = {
        ...SourceMyAccountInformation.propTypes,
        isMobile: PropTypes.bool.isRequired,
        onChangeFile: PropTypes.func.isRequired
    };

    renderAccountStatus() {
        const { isMobile } = this.props;

        if (isMobile) {
            return null;
        }

        return <MyAccountStatusMessage />;
    }

    /**
     * Override: add onChangeFile to handle documents
     * @returns {JSX.Element}
     */
    renderCustomerForm() {
        const {
            customer,
            onCustomerSave,
            showEmailChangeField,
            showPasswordChangeField,
            handleChangeEmailCheckbox,
            handleChangePasswordCheckbox,
            onChangeFile
        } = this.props;

        return (
            <MyAccountCustomerForm
              customer={ customer }
              onSave={ onCustomerSave }
              showEmailChangeField={ showEmailChangeField }
              showPasswordChangeField={ showPasswordChangeField }
              handleChangeEmailCheckbox={ handleChangeEmailCheckbox }
              handleChangePasswordCheckbox={ handleChangePasswordCheckbox }
              onChangeFile={ onChangeFile }
            />
        );
    }

    /**
     * Override: add account status message on desktop (because of redirection from dashboard)
     * @return {JSX.Element}
     */
    render() {
        const { isLoading } = this.props;

        return (
            <div
              block="MyAccountInformation"
              elem="Wrapper"
            >
                <Loader isLoading={ isLoading } />
                { this.renderAccountStatus() }
                { this.renderCustomerForm() }
            </div>
        );
    }
}

export default MyAccountInformationComponent;
